import { render, staticRenderFns } from "./Echart04.vue?vue&type=template&id=2c8e94b2&"
import script from "./Echart04.vue?vue&type=script&lang=js&"
export * from "./Echart04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports